@if (link(); as item) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
          <i class="pi pi-info-circle text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información general</span>
      </div>
      <div class="p-4">
        <div class="flex items-center gap-2 mb-4 pb-3 border-b border-slate-100">
          <div class="shrink-0 flex items-center justify-center [&>i]:text-xs" [class]="statusIconClasses(item.status)">
            <i [class]="statusIcon(item.status)"></i>
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap gap-1">
              <span class="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{{ statusLabel(item.status) }}</span>
              <span class="text-[10px] px-1.5 py-0.5 rounded bg-sky-100 text-sky-700">{{ typeLabel(item.type) }}</span>
              @if (item.type === 'SUBSCRIPTION' && item.frequency) {
                <span class="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{{ frequencyLabel(item.frequency) }}</span>
              }
            </div>
            <p class="mt-1 text-sm font-semibold text-slate-900 font-mono">{{ item.number || '—' }}</p>
          </div>
          <span class="text-sm font-bold text-slate-900 shrink-0 tabular-nums">
            {{ (item.currentTotal ?? 0) | currency:(item.currencyCode || 'MXN'):'symbol':'1.2-2' }}
          </span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de creación</p>
            <p class="text-sm text-slate-700">{{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy h:mm a') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Vigencia</p>
            <p class="text-sm text-slate-700">{{ item.expiresAt ? (item.expiresAt | date:'dd/MM/yyyy h:mm a') : 'Sin vigencia' }}</p>
          </div>
          @if (hasNotes(item.notes)) {
            <div class="sm:col-span-2">
              <p class="text-xs font-medium text-slate-500">Notas</p>
              <div
                class="mt-1 text-sm text-slate-700 max-w-full overflow-x-auto break-words [overflow-wrap:anywhere] [&_img]:max-w-full [&_img]:h-auto"
                [innerHTML]="item.notes">
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
          <i class="pi pi-user text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Cliente</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-medium text-slate-500">Nombre</p>
            <p class="text-sm font-medium text-slate-900">{{ item.customerName || '—' }}</p>
          </div>
          @if (item.customerTaxId) {
            <div>
              <p class="text-xs font-medium text-slate-500">RFC</p>
              <p class="text-sm text-slate-700 font-mono">{{ item.customerTaxId }}</p>
            </div>
          }
          @if (item.customerEmail) {
            <div>
              <p class="text-xs font-medium text-slate-500">Email</p>
              <a [href]="'mailto:' + item.customerEmail" class="text-sm text-sky-600 hover:text-sky-800">{{ item.customerEmail }}</a>
            </div>
          }
        </div>
      </div>
    </div>

    @if (item.lines && item.lines.length > 0) {
      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
            <i class="pi pi-list text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Líneas ({{ item.lines.length }})</span>
        </div>
        <div class="divide-y divide-slate-100">
          @for (line of item.lines; track line.id ?? $index) {
            <div class="flex items-center gap-2 px-4 py-2">
              <div class="shrink-0 flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sky-600 [&>i]:text-xs">
                <i class="pi pi-box"></i>
              </div>
              <div class="min-w-0 flex-1">
                <p class="text-xs font-medium text-slate-900 truncate">{{ line.description || line.productName || 'Sin descripción' }}</p>
                @if (line.quantity != null && line.unitPrice != null) {
                  <p class="text-[11px] text-slate-500 mt-0.5">
                    {{ line.quantity }} × {{ line.unitPrice | currency:(item.currencyCode || 'MXN'):'symbol':'1.2-2' }}
                  </p>
                }
              </div>
              <span class="text-xs font-bold text-slate-900 shrink-0 tabular-nums">
                {{ lineAmount(line.quantity, line.unitPrice) | currency:(item.currencyCode || 'MXN'):'symbol':'1.2-2' }}
              </span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
